// A route can carry a `messageId` (deep-link from the Contact Timeline or
// search) pointing at a conversation that's already the active chat. In
// that case `setActiveChat` skips re-dispatching `setActiveChat` (the chat
// is already loaded), but a `SCROLL_TO_MESSAGE` bus event still needs to
// fire so `MessagesView` scrolls to the requested message.
export const shouldScrollToAlreadyActiveMessage = (
  selectedConversationId,
  currentChatId,
  messageId
) => selectedConversationId === currentChatId && !!messageId;
